import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-urgent text-white py-3 px-4 shadow-md" data-id="element-93">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center text-center md:space-x-4 text-sm md:text-base font-medium" data-id="element-94">
        <p data-id="element-95">
          <span className="font-bold" data-id="element-96">¡OFERTA DE LANZAMIENTO!</span> 70% OFF
          disponible solo por las próximas 24 horas o hasta agotar 100 cupos.
        </p>
        <div className="flex items-center space-x-3 mt-2 md:mt-0 bg-black/20 px-3 py-1 rounded-full" data-id="element-97">
          <div className="flex items-center space-x-1 font-mono font-bold tracking-wider" data-id="element-98">
            <span data-id="element-99">{formatTime(timeLeft.hours)}</span>
            <span data-id="element-100">:</span>
            <span data-id="element-101">{formatTime(timeLeft.minutes)}</span>
            <span data-id="element-102">:</span>
            <span data-id="element-103">{formatTime(timeLeft.seconds)}</span>
          </div>
          <span className="w-1 h-1 bg-white rounded-full opacity-50" data-id="element-104"></span>
          <span className="text-xs font-bold text-white/90" data-id="element-105">
            Quedan 37 cupos
          </span>
        </div>
        <p className="mt-1 text-[11px] italic text-white/40 leading-snug max-w-2xl md:hidden" data-id="element-106">
          Actualizado hace 2 min. Luego de 100 cupos, sube a ARS 45.000.
        </p>
        <p className="mt-1 text-[11px] italic text-white/40 leading-snug max-w-2xl hidden md:block" data-id="element-107">
          Actualizado hace 2 minutos. Una vez agotados los 100 cupos de
          preventa, el sistema regresará a su precio original de ARS 45.000 sin
          excepciones.
        </p>
      </div>
    </div>;
}